import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'purchase-bar',
  name: '购买操作栏',
  icon: '购',
  group: '商品详情页',
  description: '客服、收藏、购物车和立即购买操作',
  defaultProps: {
    showService: true,
    showFavorite: true,
    cartText: '加入购物车',
    buyText: '立即购买'
  }
}
